import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { getAccessToken, fetchData } from '../common/MSALHelper';
import './ParishionerList.css';
import { Link, useNavigate } from "react-router-dom";

export default function ParishionerList({item}) {
    const { instance, accounts } = useMsal();
    // const [accessToken, setAccessToken] = useState(null);
    const [data, setData] = useState(null);
    const [filterValue, setFilterValue] = useState('');

    let navigate = useNavigate();

    // Function to handle textbox change
    const handleFilterChange = (event) => {
        setFilterValue(event.target.value);
    };

    const getDataDisplay = function () {
        if (data) {
            if (Array.isArray(data)) {
                const filteredData = data.filter(item => !filterValue || (item["ChiHoi"] && item["ChiHoi"].toLowerCase().includes(filterValue.toLowerCase())));
                return <table>
                    <thead>
                        <tr>
                            <th>Member ID</th>
                            <th>Last Name</th>
                            <th>Middle Name</th>
                            <th>First Name</th>
                            <th>Chi Hội</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Postal Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map(item =>
                        (
                            <tr key={item["ID"]}>
                                <td><Link to={`/CommunityMember/${item["ID"]}`}>{item["ID"]}</Link></td>
                                <td>{item["LastName"]}</td>
                                <td>{item["MiddleName"]}</td>
                                <td>{item["FirstName"]}</td>
                                <td>{item["ChiHoi"]}</td>
                                <td>{item["Address"]}</td>
                                <td>{item["City"]}</td>
                                <td>{item["State"]}</td>
                                <td>{item["PostalCode"]}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }
            else
                return <div>{data.message}</div>;
        }
        else
            return <div>Loading</div>
    };

    useEffect(() => {
        getAccessToken(instance, accounts).then((response) => {
            let accessToken = response;
            fetchData(accessToken, '/users', response => response.json(), data => {
                console.log(data)
                setData(data);
            });
        });
    }, [instance, accounts]);

    return (
        <div>
            {/* Label for the input */}
            <label htmlFor="searchInput">Search Chi Hội</label>
            {/* Textbox for filtering */}
            <input
                type="text"
                id="searchInput"
                placeholder="Enter Chi Hội..."
                value={filterValue}
                onChange={handleFilterChange}
            />
            <button className="AddButton" onClick={() => navigate(`/CommunityMember/new`)}>Add New Community Member</button>
            {getDataDisplay()}
        </div>
    );
}